import React from "react";
import ContractGenericSkeleton from "./ContractGenericSkeleton";

function ContractDetailSkeleton() {
  return (
    <>
      <ContractGenericSkeleton />
    </>
  );
}

export default ContractDetailSkeleton;
